module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 11\"><path d=\"M9 6.88 2.08 0 0 2.06 9 11l9-8.94L15.92 0z\"></path></svg>"